const STORAGE_KEY = "link.ignored.accounts";
const EVENT = "link:ignored-accounts-changed";

export function ignoredAccounts(): Set<string> {
  if (typeof window === "undefined") return new Set();
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? "[]") as unknown;
    return new Set(Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === "string") : []);
  } catch {
    return new Set();
  }
}

export function isIgnored(accountXid: string): boolean {
  return ignoredAccounts().has(accountXid);
}

export function ignoreAccount(accountXid: string): void {
  const next = ignoredAccounts();
  next.add(accountXid);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...next]));
  window.dispatchEvent(new Event(EVENT));
}

export function onIgnoredAccountsChanged(listener: () => void): () => void {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
